module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-nav', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.previosMaintain
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n          ")], 1)], 1), _vm._v(" "), _c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("Shipping Line Branch")]), _vm._v(" "), _c('b-navbar-nav', {
    staticClass: "ml-auto"
  }, [_c('b-nav-form', [(_vm.showMain == false) ? _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": _vm.goToMain
    }
  }, [_vm._v("New Branch")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('b-card', {
    staticClass: "formCard"
  }, [_c('b-card-text', [(_vm.showMain == true) ? _c('div', [_c('b-container', [_c('b-card', {
    staticStyle: {
      "background": "whiteSmoke"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "35"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Branch Name")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "shippingBranch",
      "name": "shippingBranch"
    },
    model: {
      value: (_vm.shipLine.shippingBranch),
      callback: function($$v) {
        _vm.$set(_vm.shipLine, "shippingBranch", $$v)
      },
      expression: "shipLine.shippingBranch"
    }
  })], 1), _vm._v(" "), (!_vm.shipLine.shippingBranch) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.shippingLineError))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("GST No")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "gstNo",
      "name": "gstNo"
    },
    model: {
      value: (_vm.shipLine.gstNo),
      callback: function($$v) {
        _vm.$set(_vm.shipLine, "gstNo", $$v)
      },
      expression: "shipLine.gstNo"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("PAN No")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "panNo",
      "name": "panNo"
    },
    model: {
      value: (_vm.shipLine.panNo),
      callback: function($$v) {
        _vm.$set(_vm.shipLine, "panNo", $$v)
      },
      expression: "shipLine.panNo"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "35"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Contact Person Name")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "contactPerson",
      "name": "contactPerson"
    },
    model: {
      value: (_vm.shipLine.contactPerson),
      callback: function($$v) {
        _vm.$set(_vm.shipLine, "contactPerson", $$v)
      },
      expression: "shipLine.contactPerson"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Contact No")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "contactNo",
      "name": "contactNo"
    },
    model: {
      value: (_vm.shipLine.contactNo),
      callback: function($$v) {
        _vm.$set(_vm.shipLine, "contactNo", $$v)
      },
      expression: "shipLine.contactNo"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Email-Id")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "email",
      "name": "email"
    },
    model: {
      value: (_vm.shipLine.email),
      callback: function($$v) {
        _vm.$set(_vm.shipLine, "email", $$v)
      },
      expression: "shipLine.email"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "90"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Shipping Line Address")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "address",
      "name": "address"
    },
    model: {
      value: (_vm.shipLine.address),
      callback: function($$v) {
        _vm.$set(_vm.shipLine, "address", $$v)
      },
      expression: "shipLine.address"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "mrgtop-2per gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "85"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "primary",
      "id": "addButtonLoader"
    },
    on: {
      "click": _vm.addVehicleSize
    }
  }, [_vm._v(_vm._s(_vm.shipLine.shippingBranchId == '' ? "Add" : "Update"))]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loader"
    }
  })], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body gutr"
  }, [_c('table', {
    staticClass: "table",
    attrs: {
      "id": "shipping"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Sr.no")]), _vm._v(" "), _c('th', [_vm._v("Branch")]), _vm._v(" "), _c('th', [_vm._v("Contact Details")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.shippingDetails), function(item1, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "showMoreData",
      on: {
        "click": function($event) {
          _vm.editData(item1)
        }
      }
    }, [_c('b', [_vm._v(_vm._s(item1.shippingBranch))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("GST No. :")]), _vm._v("\n                      " + _vm._s(item1.gstNo) + "\n                      "), _c('br'), _vm._v(" "), _c('span', [_vm._v("PAN No. :")]), _vm._v("\n                      " + _vm._s(item1.panNo) + "\n                    ")]), _vm._v(" "), _c('td', [_c('span', [_vm._v("Address :")]), _vm._v("\n                      " + _vm._s(item1.address) + "\n                      "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Contact Person Name :")]), _vm._v("\n                      " + _vm._s(item1.contactPerson) + "\n                      "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Contact No. :")]), _vm._v("\n                      " + _vm._s(item1.contactNo) + "\n                      "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Email :")]), _vm._v("\n                      " + _vm._s(item1.email) + "\n                    ")])])
  }))])])])])], 1)], 1)], 1), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop6",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onClose6
    }
  }), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  }), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop3",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-60409796","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/yard/newShippingBranch.vue
// module id = 2673
// module chunks = 0